import { SETTINGS_RESOURCES, PAGE_NAMES } from 'constant';
import user from 'assets/settings/user.png';
import role from 'assets/settings/role.png';

import UserDashboard from './userManagement';
import RoleDashboard from './roles';

export const URL = {
	[SETTINGS_RESOURCES.user]: `/${PAGE_NAMES.settings}/${SETTINGS_RESOURCES.user}`,
	[SETTINGS_RESOURCES.role]: `/${PAGE_NAMES.settings}/${SETTINGS_RESOURCES.role}`
};

export const LABEL = {
	[SETTINGS_RESOURCES.user]: 'User Management',
	[SETTINGS_RESOURCES.role]: 'Role Management'
};

export const COMPONENT = {
	[SETTINGS_RESOURCES.user]: UserDashboard,
	[SETTINGS_RESOURCES.role]: RoleDashboard
};

export const IMAGE_SOURCE = {
	[SETTINGS_RESOURCES.user]: user,
	[SETTINGS_RESOURCES.role]: role
};
